import * as React from 'react';

import AllNewBox140 from './AllNewBox140';

export const allNewBox140 = () => <AllNewBox140 />;

export default {
    title: 'Illustration|AllNewBox140',
    component: AllNewBox140,
    parameters: {
        notes: "`import AllNewBox140 from 'box-ui-elements/es/illustration/AllNewBox140';`",
    },
};
